export default __webpack_public_path__ + "9cf9812dba474756bda903cc10af27db.png";